export default __webpack_public_path__ + "static/img-3-f9fc6bc75c37cee872bd7af624bb4dce.png";